import { createVNode, render } from 'vue'
import ModalWrapper from './ModalWrapper.vue'

export function openModal(modalComponent, props, instance, { onOpen } = {}) {
  return new Promise((resolve, reject) => {
    if (!instance) {
      throw new Error('openModal must be called within a setup function or a Vue component context')
    }

    const container = document.createElement('div')
    document.body.appendChild(container)

    const modalVNode = createVNode(ModalWrapper, {
      modalComponent,
      props,
      onResolve: (value) => {
        render(null, container)
        container.remove()
        resolve(value)
      },
      onReject: (value) => {
        render(null, container)
        container.remove()
        reject(value)
      },
      onClose: () => {
        render(null, container)
        container.remove()
        reject('Action needs to be taken')
      },
      onOpen,
    })

    // Use the app context from the current instance
    modalVNode.appContext = instance.appContext || instance._context
    render(modalVNode, container)
  })
}

export default openModal
